import { useState, useEffect } from "react";
import axios from "axios"


//Cadastrar Equipamentos
import EditarEquipamento from './components/Editar-cadastro.js';
import ListarEquipamento from './components/Grid-materiais-cadastrados.js';
import Cadastrar from './components/Novo-cadastro-equipamento.js';
import VerEquipamento from './components/Ver-equipamento.js';

import GlobalStyle from "../../../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";




import RedButton from "../../../ui/RedButton.js";

const Div = styled.div`
  display: flex;
  
  flex-direction: column;


`;

const Container = styled.div`
  width: 89.2vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;



  div{
    width: 89.3vw;
    border-radius:15px;

  }
`;

const Div2 = styled.div`
  width: 60vw;
  display: flex;
  justify-content: center; 
  align-items: center;


`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: end; 
`;

const ButtonClose = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  transition: transform 1.5s;
  &:hover {
    transform: scale(1.2);
  }
`;



const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
`;
const ModalContent = styled.div`
  background-color: #fafafa;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh; 
  overflow-y: auto; 
  border-radius: 10px;
  

`;


function Usuarios({ urlApi }) {

  const token = localStorage.getItem('token');




  //------------------------------------------TIPO/SUBTIPO MATERIAL-----------------------------------------------------------------//

  const [tipoPosse, setTipoPosse] = useState([]);
  const [tipoEquipamento, setTipoEquipamento] = useState([]);
  const [setorEquipamento, setSetorEquipamento] = useState([]);
  const [usuarioEquipamento, setUsuarioEquipamento] = useState([]);

  const getTipo = async () => {
    try {
      const res = await axios.get(`${urlApi}central-ti/tipo-posse`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTipoPosse(res.data);

      const res2 = await axios.get(`${urlApi}central-ti/tipo-equipamento`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTipoEquipamento(res2.data);

      const res3 = await axios.get(`${urlApi}central-ti/setor-equipamento`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSetorEquipamento(res3.data);

      const res4 = await axios.get(`${urlApi}central-ti/usuario-equipamento`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsuarioEquipamento(res4.data);

    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };


  useEffect(() => {
    getTipo();
  }, []);

  //------------------------------------------LISTA MATERIAL-----------------------------------------------------------------//

  const [listaEquipamento, setListaEquipamento] = useState([]);
  const [atualizaMateriais, setAtualizaMateriais] = useState(false);

  const getListaEquipamentos = async () => {
    try {
      const res = await axios.get(`${urlApi}central-ti/lista-equipamentos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaEquipamento(res.data);
      if (res.data) {
        setAtualizaMateriais(false);
      }

    } catch (err) {
      console.log("Conexão falhou", err);
    }

  };




  useEffect(() => {

    getListaEquipamentos();
  }, [atualizaMateriais]);





  //---------------------------------------MODAL EDITAR DE EQUIPAMENTO---------------------------------------------------//
  const [editarEquipamentos, setEditarEquipamentos] = useState([])
  const [isModalOpenEditarEquipamentos, setIsModalOpenEditarEquipamentos] = useState(false);
  const modalEditarEquipamentos = () => {
    setIsModalOpenEditarEquipamentos(!isModalOpenEditarEquipamentos);

  };



  //---------------------------------------MODAL CADASTRAR EQUIPAMENTO---------------------------------------------------//

  const [isModalOpenCadastrarEquipamento, setIsModalOpenCadastrarEquipamento] = useState(false);
  const modalCadastrarEquipamento = () => {
    setIsModalOpenCadastrarEquipamento(!isModalOpenCadastrarEquipamento);
  };

  //---------------------------------------MODAL VER EQUIPAMENTO---------------------------------------------------//

  const [isModalOpenVerEquipamento, setIsModalOpenVerEquipamento] = useState(false);
  const modalVerEquipamento = (item) => {
    setIsModalOpenVerEquipamento(!isModalOpenVerEquipamento);
    setEditarEquipamentos(item);
  };


  return (
    <>

      <Div2>
        {isModalOpenCadastrarEquipamento && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <RedButton onClick={() => {
                  modalCadastrarEquipamento();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <Cadastrar
                urlApi={urlApi}
                tipoPosse={tipoPosse}
                tipoEquipamento={tipoEquipamento}
                setorEquipamento={setorEquipamento}
                setAtualizaMateriais={setAtualizaMateriais}
                usuarioEquipamento={usuarioEquipamento}
              />
            </ModalContent>
          </ModalContainer>
        )}

        {isModalOpenEditarEquipamentos && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>

                <RedButton onClick={() => {
                  modalEditarEquipamentos();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <EditarEquipamento
                urlApi={urlApi}
                tipoPosse={tipoPosse}
                tipoEquipamento={tipoEquipamento}
                setorEquipamento={setorEquipamento}
                setAtualizaMateriais={setAtualizaMateriais}
                editarEquipamentos={editarEquipamentos}
                usuarioEquipamento={usuarioEquipamento}
              />
            </ModalContent>
          </ModalContainer>
        )}
        {isModalOpenVerEquipamento && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>


                <RedButton onClick={() => {
                  modalVerEquipamento();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <VerEquipamento
                urlApi={urlApi}
                tipoPosse={tipoPosse}
                tipoEquipamento={tipoEquipamento}
                editarEquipamentos={editarEquipamentos}
                usuarioEquipamento={usuarioEquipamento}
                setIsModalOpenVerEquipamento={setIsModalOpenVerEquipamento}
                setIsModalOpenEditarEquipamentos={setIsModalOpenEditarEquipamentos}
                setAtualizaMateriais={setAtualizaMateriais}
              />
            </ModalContent>
          </ModalContainer>
        )}
      </Div2>

      <Div>
        <Container>
          <ListarEquipamento
            urlApi={urlApi}
            listaEquipamento={listaEquipamento}
            modalCadastrarEquipamento={modalCadastrarEquipamento}
            modalVerEquipamento={modalVerEquipamento}
            setAtualizaMateriais={setAtualizaMateriais}
            tipoPosse={tipoPosse}
            tipoEquipamento={tipoEquipamento}
          />



        </Container>

        <div>
          <ToastContainer
            autoClose={2500}
            position={toast.POSITION.BOTTOM_LEFT}
            style={{ width: '400px', fontSize: '22px' }}
          />

        </div>
      </Div>

      <GlobalStyle />
    </>
  );
}

export default Usuarios;
